import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MarcaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MARCA' htmlFor='input-marca' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='marca'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-marca'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MarcaFormGroup)
